import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCarriersRequest } from '../store/workkardFormSlice';
import { selectCarriers, selectAreCarriersLoading, selectCarriersLoaded } from '../store/selectors';

export function useCarriers() {
  const dispatch = useDispatch();
  const carriers = useSelector(selectCarriers);
  const carriersLoading = useSelector(selectAreCarriersLoading);
  const carriersLoaded = useSelector(selectCarriersLoaded);
  const hasRequestedRef = useRef(false);

  useEffect(() => {
    if (hasRequestedRef.current || carriersLoaded || carriersLoading) return;
    hasRequestedRef.current = true;
    dispatch(fetchCarriersRequest());
  }, [dispatch, carriersLoaded, carriersLoading]);

  return { carriers, carriersLoading };
}
